import React from "react";

export default class DefaultLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: undefined,
      isLoading: true,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.group_ids !== prevProps.group_ids ||
      this.props.group_categories !== prevProps.group_categories ||
      this.props.resident_statuses !== prevProps.resident_statuses ||
      this.props.start_date !== prevProps.start_date ||
      this.props.end_date !== prevProps.end_date ||
      this.props.therapist !== prevProps.therapist ||
      this.props.slug !== prevProps.slug ||
      this.props.resident_id !== prevProps.resident_id
    ) {
      this.fetchData();
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    this.setState({ isLoading: true, processing: true });
    const {
      organization_name,
      metric,
      group_ids,
      group_categories,
      start_date,
      end_date,
      therapist,
      resident_statuses,
      resident_id,
    } = this.props;
    let therapistFilter = therapist
      ? `&therapist=${therapist}`
      : "&therapist=all";
    const residentFilter = resident_id ? `&resident_id=${resident_id}` : "";
    let data = {
      number_member_sober_livings: 2,
      zip_code_distribution: [{name: '50%', value: 90288}, {name: '50%', value: 91188}],
      number_of_residents_total: 18,
      number_of_residents_per_sober_living_1: 10,
      number_of_residents_per_sober_living_2: 8,
      number_of_vacant_beds_per_sober_living_1: 0,
      number_of_vacant_beds_per_sober_living_2: 0,
      membership_form: 2,
      resident_move_in: 1,
    }
    this.setState((prevState, props)=>{
      return {
        isLoading: false,
        data: data[metric.endpoint],
        processing: false
      }
    })
  }
}
